import React from "react";

export default function WordWide() {
  return (
    <div className="bg-[#0a0c1a] mt-[100px] mb-[100px] flex justify-center p-1.5 sm:p-2 md:p-3  items-center">
      <div className="  container  flex flex-col  lg:flex-row items-center gap-10 text-sidom-light  ">
        <div className="flex justify-center   items-center rounded-2xl">
          <div className="w-full h-full     flex items-stretch">
            <video
              autoPlay
              muted
              loop
              className=" h-full max-w-screen-sm  max-h-[700px]"
            >
              <source
                src="https://api.institucional.global.sidom.io/uploads/sidom_hiro_eb42eafb6c.mp4"
                type="video/webm"
              />
            </video>
          </div>
        </div>

        <div className=" leading-[1.3]   lg:text-left w-full p-2 md:p-0 md:w-[40%]">
          <h2 className="text-sidom-orange text-3xl font-bold mb-4">
            Worldwide
          </h2>
          <p className="text-lg text-left">
            Con presencia en 14 países y 3 continentes, SIDOM Suite se posiciona
            como la solución integral elegida por las principales empresas con
            operaciones y filiales internacionales.
          </p>
        </div>
      </div>
    </div>
  );
}
